import * as React from 'react';

export const Social = () => (
  <svg viewBox='0 0 55 56'>
    <path
      d={`M43.6 45.7c6.2-.8 10.3-2.6 10.3-2.6 0-8-4.8-14.7-12.3-16.4v-1.9M31.6 \
      3.4C33.3 1.9 35.5 1 38 1c5.3 0 9.6 4.3 9.6 9.6v4.5c0 4-2.5 7.4-6 8.9-1.1.5-2.3.7-3.6.7 0 \
      0-1.6 0-2.7-.9M24.6 31.1v1.3c0 2.4-2 4.4-4.4 4.4s-4.4-1.9-4.4-4.4v-1.3C6.8 33.1 1 41.2 1 \
      50.9c0 0 8.1 3.5 19.3 3.5s19.3-3.5 19.3-3.5c0-9.7-5.8-17.8-15-19.8z`}
      fill='none'
      stroke='#456EDE'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.3 29.7c-1.5 0-3-.3-4.4-.9v3.5c0 2.4 1.9 4.4 4.4 4.4s4.4-1.9 4.4-4.4v-3.5c-1.4.6-2.9.9-4.4.9z'
      fill='none'
      stroke='#456EDE'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d={`M9.1 9.9c-.2.9-.4 1.8-.4 2.8v5.5c0 4.9 3 9 7.2 10.7 1.3.5 2.8.9 4.4.9 1.5 0 3-.3 \
      4.4-.9 4.2-1.7 7.2-5.9 7.2-10.7v-1.4C14.8 18.7 9.3 10.2 9.1 9.9z`}
      fill='none'
      stroke='#456EDE'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d={`M31.6 10.2C30.5 5 25.9 1.1 20.3 1.1c-5.4 0-10 3.7-11.2 8.8.2.3 5.7 \
      8.8 22.8 6.9 1-.1 2.1-.3 3.2-.4-.1-.1-2.4-2.2-3.5-6.2z`}
      fill='none'
      stroke='#456EDE'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);


// WEBPACK FOOTER //
// src/app/src/components/Icons/Social.tsx